import { defineMessages } from 'react-intl';
import toastr from 'toastr';

const messages = defineMessages({
  Success: 'Success',
  ChangesSaved: 'Changes saved',
  SomethingWentWrong: 'Something went wrong',
});

const ToastrService = {
  success(title, content, onClick = null) {
    if (!title && !content) title = 'Succes';
    if (onClick) {
      toastr.options.onclick = onClick;
    } else {
      toastr.options.onclick = null;
    }
    toastr.options.preventDuplicates = false;
    toastr.options.closeButton = true;
    toastr.options.escapeHtml = true;

    toastr.success(content, title, {
      timeOut: 8000,
    });
  },

  generalError(intl) {
    toastr.options.onclick = null;
    toastr.options.preventDuplicates = true;
    toastr.options.closeButton = true;
    toastr.options.escapeHtml = true;

    toastr.error(intl.formatMessage(messages.SomethingWentWrong), '', {
      timeOut: 8000,
    });
  },

  error(content) {
    toastr.options.onclick = null;
    toastr.options.preventDuplicates = true;
    toastr.options.closeButton = true;
    toastr.options.escapeHtml = true;

    toastr.error(content, '', {
      timeOut: 8000,
    });
  },

  info(content, title, onClick = null) {
    if (onClick) {
      toastr.options.onclick = onClick;
    } else {
      toastr.options.onclick = null;
    }
    toastr.options.preventDuplicates = true;
    toastr.options.closeButton = true;
    toastr.options.escapeHtml = true;

    toastr.info(content, title, {
      timeOut: 8000,
    });
  },
  warning(content, title, onClick) {
    if (onClick) {
      toastr.options.onclick = onClick;
    } else {
      toastr.options.onclick = null;
    }
    toastr.options.preventDuplicates = true;
    toastr.options.closeButton = true;
    toastr.options.escapeHtml = true;

    toastr.warning(content, title, {
      timeOut: 8000,
    });
  },

  changesSaved(intl, onClick, preventDuplicates = false) {
    let title = 'Success';
    let content = '';
    if (intl && typeof intl.formatMessage === 'function') {
      title = intl.formatMessage(messages.Success);
      content = intl.formatMessage(messages.ChangesSaved);
    }
    if (onClick) {
      toastr.options.onclick = onClick;
    } else {
      toastr.options.onclick = null;
    }
    toastr.options.preventDuplicates = preventDuplicates;
    toastr.options.closeButton = true;
    toastr.options.escapeHtml = true;

    toastr.success(content, title, {
      timeOut: 8000,
    });
  },
};

export default ToastrService;
